import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { priceUpdateMiddleware } from 'features/subscription-process/pricing-process/slices/pricing/middlewares/priceUpdateMiddleware';
import {
  persistReducer,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import rootReducer from './reducers';

// État persisté en sessionStorage, propre à chaque onglet (comme le jeton d'accès
// et la session OIDC) : en localStorage, `persist:root` était commun à tous les
// onglets et un onglet rechargeait le panier, la tarification et l'utilisateur
// d'un autre compte. Un rechargement garde l'état de l'onglet ; un nouvel onglet
// démarre vide.
const PERSIST_ROOT_KEY = 'persist:root';

// Ancien emplacement partagé entre onglets : on n'y laisse aucun état.
try {
  localStorage.removeItem(PERSIST_ROOT_KEY);
} catch {
  // stockage indisponible : rien à effacer
}

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  // abp : jamais persisté — les grantedPolicies sont scopées au rôle/portail
  // actif de la session ; réhydratées avec initialized=true, elles ne seraient
  // jamais refetchées et un login sous une autre casquette filtrerait le menu
  // avec les permissions de la session précédente (onglets manquants).
  blacklist: ["pricing", "pricingValues", "contractualization", "mandate", "quote", "contractSignature", "tables", "abp"]
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(priceUpdateMiddleware)
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;

